import React, { useContext, useEffect } from "react";
import { Card } from "../common/Card";
import completedIcon from "../../images/icon-completed.svg";
import { ZahtjevContext } from "../../common/context/ZahtjevProvider";
import { FINAL_STATUS } from "../../common/constants/navigationConstants";
import { Button } from "../common/Button";
import { useTranslation } from "react-i18next";

export function FinalPage() {
    const { t } = useTranslation();
    const { restoreContext, isProcessCompleted } = useContext(ZahtjevContext);
    const pageStatus = FINAL_STATUS;

    const handleReturnToMainPage = () => {
        window.location.href = process.env.REACT_APP_MAIN_PAGE!;
    };

    useEffect(() => {
        if (!isProcessCompleted) {
            restoreContext(pageStatus);
        }
    }, []);

    return (
      <Card isLoading={!isProcessCompleted} centerContext={true}>
          <div className="flex flex-col items-center text-center">
              <img src={completedIcon} alt="" />
              <h1
                className="font-extrabold text-xl sm:text-2xl md:text-3xl leading-tight mb-5 mt-5 font-sans">{t("final-page.title")}</h1>
              <div className="flex flex-col mb-5 mt-5 items-center w-md-75">
                  <p className="font-bold text-lg sm:text-xl md:text-2xl leading-tight font-sans">{t("final-page.description-first")}</p>
                  <p className="text-base sm:text-lg md:text-xl leading-tight font-sans">{t("final-page.description-second")}</p>
              </div>

              <Button className="mt-5" text={t("common.button-return")} onClick={handleReturnToMainPage} />
          </div>
      </Card>
    )
}
